/**
 * Component which used on common-summary srceens to show info about
 * finished flows.
 */
import { LitElement, css, customElement, html } from 'lit-element';
import { B_ITEM, C_ITEM, PL_ITEM } from '../boilerplate/item-names';
import getItemName from '../utils/get-item-name';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
@customElement('item-box')
class ItemBoxComponent extends LitElement {
  static get properties() {
    return {
      id: { type: String },
      title: { type: String },
      edit_screen: { type: String },
      color: { type: String },
      icon: { type: String },
      request_id: { type: String },
    };
  }

  constructor() {
    super();
    this.request_id = '';
    this.title = '';
    this.edit_screen = '';
    this.color = '';
    this.icon = '';
  }

  static get styles() {
    return css`
      .item-box-container {
        display: flex;
        padding-left: 15px;
        background-color: #fff;
        border: 1px solid #efe6dc;
        border-bottom: none;
      }

      .item-box-container .item-icon {
        width: 50px;
      }

      .item-box-container .control-button {
        width: 29px;
      }

      .item-box-container .item-title {
        align-self: center;
        width: calc(100% - 108px);
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item-box-container div {
        padding: 35px 0;
      }

      .blue .item-title {
        color: #433894;
      }

      .orange .item-title {
        color: #fb8900;
      }

      .red .item-title {
        color: #f05d23;
      }

      .item-title {
        font-size: 26px;
      }

      .control-button {
        border-left: 1px solid #efe6dc;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      @media only screen and (max-width: 576px) {
        .item-title {
          font-size: 18px;
        }
      }
    `;
  }

  render() {
    return html`
      <div class="item-box-container ${this.color}">
        <div class="item-icon">${this.returnAsHtml(this.icon)}</div>
        <div class="item-title">${this.kasko.getTranslation(this.title)}</div>
        <div class="left-border control-button" @click=${() => this.editItem()}>
          <?xml version="1.0" encoding="UTF-8"?>
          <svg
            width="18px"
            height="18px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Icon-small/Bearbeiten</title>
            <g
              id="Icon-small/Bearbeiten"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M19.2664461,1 C20.213739,1 21.1623259,1.36752892 21.8960897,2.10258676 C23.3674994,3.57270244 23.3674994,5.89175815 21.8960897,7.36187383 L21.8960897,7.36187383 L7.58834412,21.6709135 L7.30493273,21.7278546 L2.32776293,22.7165591 L1,22.9999705 L1.28211727,21.6709135 L2.27211594,16.6937437 L2.32776293,16.4103323 L16.6368026,2.10258676 C17.3718604,1.36752892 18.3191533,1 19.2664461,1 Z M3.91176081,17.7122129 L3.31905572,20.6809148 L6.28646351,20.0869156 C5.84905233,19.0024465 4.99752406,18.1496241 3.91176081,17.7122129 L3.91176081,17.7122129 Z M16.0143328,5.29775895 L5.07128866,16.2408031 C6.23081652,16.8348023 7.1638741,17.7678599 7.7578733,18.9273877 L7.7578733,18.9273877 L18.7009175,7.98434358 L16.0143328,5.29775895 Z M19.2664461,2.7237624 C18.8109173,2.7237624 18.3515062,2.93340917 17.9089185,3.3747027 L17.9089185,3.3747027 L17.2864488,4.02564301 L19.9743275,6.71222764 L20.6239737,6.08975789 C21.5039725,5.20975907 21.5039725,4.25599564 20.6239737,3.3747027 C20.1826802,2.93340917 19.7219749,2.7237624 19.2664461,2.7237624 Z"
                id="Combined-Shape"
                fill="#787772"
              ></path>
            </g>
          </svg>
        </div>
        <div
          class="left-border control-button"
          @click=${() => this.removeItem()}
        >
          <?xml version="1.0" encoding="UTF-8"?>
          <svg
            width="18px"
            height="18px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Icon-small/Close</title>
            <g
              id="Icon-small/Close"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
              <polygon
                id="Path"
                fill="#787772"
                points="3.21875 1.78125 1.78125 3.21875 10.5625 12 1.78125 20.78125 3.21875 22.21875 12 13.4375 20.78125 22.21875 22.21875 20.78125 13.4375 12 22.21875 3.21875 20.78125 1.78125 12 10.5625"
              ></polygon>
            </g>
          </svg>
        </div>
      </div>
    `;
  }

  editItem() {
    if (this.kasko.getState('input').item_id === 'item_7e644b3be4c54b18c53e7138511') {
      if (this.edit_screen === 'summary') {
        this.kasko.dispatchEvent('set-state-input', {
          edited_item: 'contents',
          item_A_B: false,
          item_A: false,
        });
      } else if (this.edit_screen === 'private-liability-summary') {
        this.kasko.dispatchEvent('set-state-input', {
          edited_item: 'private-liability',
          item_A_B: false,
        });
      } else if (this.edit_screen === 'buildings-summary') {
        this.kasko.dispatchEvent('set-state-input', {
          edited_item: 'buildings',
        });
      }
    }
    this.kasko.dispatchEvent('go-to-screen', { screen: this.edit_screen });
  }

  removeItem() {
    const { language } = this.kasko.getState('input');
    if (this.edit_screen === 'summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(C_ITEM, language),
      });
    } else if (this.edit_screen === 'private-liability-summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(PL_ITEM, language),
      });
    } else if (this.edit_screen === 'buildings-summary') {
      this.kasko.dispatchEvent('set-state-input', {
        deleted_item_label: getItemName(B_ITEM, language),
      });
    }
    this.isOpened = false;
    this.kasko.dispatchEvent('set-state-input', {
      request_item_id: this.request_id,
      is_remove_item_modal: 'opened',
    });
  }

  returnAsHtml(str) {
    return document.createRange().createContextualFragment(`${str}`);
  }
}

export default ItemBoxComponent;
